"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplateDto = exports.ChannelCTADto = void 0;
class ChannelCTADto {
    type;
    data;
}
exports.ChannelCTADto = ChannelCTADto;
class MessageTemplateDto {
    type;
    content;
    contentType;
    cta;
    actor;
    variables;
    feedId;
    layoutId;
    name;
    subject;
    title;
    preheader;
    senderName;
    _creatorId;
}
exports.MessageTemplateDto = MessageTemplateDto;
//# sourceMappingURL=message-template.dto.js.map